const numberFormatter = Intl.NumberFormat('en-us', {});
export function formatNumber(value?: number, digits: number = 0, placeholder: string = ''): string {
  if (value === undefined || value === null) {
    return placeholder;
  }
  const correctDigitsValue = +value.toFixed(digits);
  return numberFormatter.format(correctDigitsValue);
}
